import { useState } from "react";
import usePageMeta from "../hooks/usePageMeta"; // ✅ custom SEO hook
import AboutUs from "../components/AboutUs";
import ContactSection from "../components/ContactSection";
import FloatingContactButton from "../components/FloatingContactButton";
import GallerySection from "../components/GallerySection";
import HomeSection from "../components/HomeSection";
import Navbar from "../components/navbar";
import ServicesSection from "../components/ServicesSection";
import GalleryModal from "../components/GalleryModal";
import ReviewsSection from "../components/ReviewSection";

const HomePage = () => {
  const [modalData, setModalData] = useState({ isOpen: false });

  // ✅ SEO Meta (using our custom hook)
  const SITE_URL =
    process.env.REACT_APP_SITE_URL || "https://www.yourdomain.com";
  usePageMeta({
    title: "KH Tiling and Painting — Professional Tiling & Painting Services",
    description:
      "KH Tiling and Painting offers professional tiling and painting for homes and businesses. Kitchens, bathrooms, interiors, exteriors — free quotes and guaranteed results.",
    canonical: `${SITE_URL}/`,
    ogImage: `${SITE_URL}/og-cover.jpg`,
  });

  // ✅ Structured Data (JSON-LD for Google SEO)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    name: "KH Tiling & Painting",
    url: `${SITE_URL}/`,
    telephone: "+61 4xx xxx xxx",
    areaServed: "Your City / Region",
    address: {
      "@type": "PostalAddress",
      addressLocality: "City",
      addressRegion: "State",
      addressCountry: "AU",
    },
    image: [`${SITE_URL}/og-cover.jpg`],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "18:00",
      },
    ],
    serviceType: ["Tiling", "Painting"],
    makesOffer: [
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Bathroom Tiling" },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Interior Painting" },
      },
    ],
  };

  const openModal = (item) => setModalData({ ...item, isOpen: true });
  const closeModal = () => setModalData({ isOpen: false });

  return (
    <div>
      {/* ✅ Structured data for Google SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      {/* ✅ Page Content */}
      <Navbar />
      <main>
        <HomeSection />
        <ServicesSection />
        <GallerySection openModal={openModal} />
        <AboutUs />
        <ContactSection />
        <FloatingContactButton />
        <ReviewsSection />
      </main>

      {/* ✅ Gallery Modal */}
      <GalleryModal
        isOpen={modalData.isOpen}
        onClose={closeModal}
        title={modalData.title}
        images={modalData.images || []}
        description={modalData.description}
      />
    </div>
  );
};

export default HomePage;
